var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAdvisor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M27.64 12.705v8.59h.713c2.318 0 3.507-1.491 3.507-4.235 0-2.923-1.189-4.355-3.507-4.355h-.713zm-21.22 8.59v-8.59h-.771c-2.318 0-3.51 1.432-3.51 4.355 0 2.744 1.192 4.235 3.51 4.235h.77zM13.792 34c-1.844 0-3.152-1.253-3.152-2.804-3.804-1.192-6.061-3.936-6.418-7.873C1.545 22.726 0 20.46 0 17.06c0-4.056 2.083-6.442 5.649-6.442h.77C6.42 4.175 10.584 0 17.06 0 23.54 0 27.7 4.175 27.7 10.618h.654c3.567 0 5.647 2.386 5.647 6.442 0 3.936-2.14 6.382-5.647 6.382H25.5V11.93c0-6.502-2.794-9.723-8.44-9.723-5.647 0-8.5 3.28-8.5 9.723v11.512H6.361c.357 2.983 1.84 4.832 4.694 5.726.475-.954 1.427-1.49 2.736-1.49 1.96 0 3.208 1.252 3.208 3.22C17 32.748 15.752 34 13.792 34z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.25-4.25h42.5v42.5h-42.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvisor);
export default __webpack_public_path__ + "static/media/icon-advisor.eee26d7f8b5a18cc902a7fcd4b8130f5.svg";
export { ForwardRef as ReactComponent };